export default __webpack_public_path__ + "static/media/Blog12.15.b28bb666.png";